// extracted by mini-css-extract-plugin
module.exports = {"panel":"PatientsOverview_panel__10q5j","group":"PatientsOverview_group__sCJQy","row":"PatientsOverview_row__1yquR","header":"PatientsOverview_header__1Tuw6"};